import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import Input from 'Webapp/shared/app/components/base/input';
import withT from 'ComponentLibrary/hocs/withT';

import { FONT_WEIGHTS } from 'Style/typography';
import { SPACING } from 'Style/spacing';

const PASSWORD_STRENGTH = ['weak', 'weak', 'medium', 'medium', 'strong'];

const StyledStrongPasswordControls = styled.div({
  display: 'grid',
  gridTemplateColumns: '1fr 1fr',
  fontSize: '12px',
  marginBottom: SPACING.MEDIUM,
  'div:first-child': {
    textAlign: 'left',
  },

  'div:last-child': {
    textAlign: 'right',
  },
});

const StyledStrongPasswordStrength = styled.span({
  fontWeight: FONT_WEIGHTS.SEMIBOLD,
});

const StyledVisibilityToggle = styled.span({
  cursor: 'pointer',
});
class StrongPasswordInput extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isPasswordVisible: false,
    };
    this.handleTogglePasswordVisibility =
      this.handleTogglePasswordVisibility.bind(this);
  }

  handleTogglePasswordVisibility() {
    this.setState({ isPasswordVisible: !this.state.isPasswordVisible });
  }

  render() {
    const { value, disabled, passwordStrength, onChange, t } = this.props;
    const { isPasswordVisible } = this.state;
    return (
      <React.Fragment>
        <div className="field-block">
          <Input
            type={isPasswordVisible ? 'text' : 'password'}
            name="password"
            placeholder={t('password')}
            value={value}
            onChange={onChange}
            disabled={disabled}
          />
        </div>
        {(passwordStrength || value) && (
          <StyledStrongPasswordControls>
            <div>
              {passwordStrength && (
                <span>
                  {t('strength')}:&nbsp;
                  <StyledStrongPasswordStrength className="strong-password__strength">
                    {t(PASSWORD_STRENGTH[passwordStrength.strength])}
                  </StyledStrongPasswordStrength>
                </span>
              )}
            </div>
            <div>
              {value && (
                <StyledVisibilityToggle
                  onClick={this.handleTogglePasswordVisibility}
                >
                  {isPasswordVisible ? t('Hide') : t('Show')}
                </StyledVisibilityToggle>
              )}
            </div>
          </StyledStrongPasswordControls>
        )}
      </React.Fragment>
    );
  }
}

StrongPasswordInput.propTypes = {
  value: PropTypes.string.isRequired,
  disabled: PropTypes.boolean,
  passwordStrength: PropTypes.object,
  t: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default withT(StrongPasswordInput);
